import {
  CandidateAiDataBuilder,
  GetCandidateAiDataInput,
  GetCandidateAiDataOutput,
} from '../candidate-ai.types';

export const getCandidateAiData = (builder: CandidateAiDataBuilder) =>
  builder.query<GetCandidateAiDataOutput, GetCandidateAiDataInput>({
    query: ({ candidateId, getOverride }) => ({
      url: `/candidates/ai/${candidateId}`,
      ...(getOverride && { params: { override: true } }),
      method: 'GET',
    }),
    providesTags: (results, args, meta) => [
      { type: 'aiData', id: meta.candidateId },
    ],
  });
